import { useSelector } from 'react-redux'

import { getRegisterFormStrings } from 'store/strings/selectors'
import { getUser } from 'store/user/selectors'
import Confirm from 'ui-component-library/components/OrderConfirmation/Confirm'

type Props = {
  isFulfilling: boolean
  onSubmit: () => void
  titleText: string
  bodyText: string
  buttonText: string
  waiverLabelText: string
  waiverLink: string
  waiverLinkText: string
  ageConfirmationLabelText: string
}

function ConfirmContainer({
  titleText,
  bodyText,
  buttonText,
  waiverLabelText,
  waiverLink,
  waiverLinkText,
  ageConfirmationLabelText,
  onSubmit,
  isFulfilling,
}: Props) {
  const user = useSelector(getUser)
  const { fullNameText, yourBirthdayText } = useSelector(getRegisterFormStrings)

  return (
    <Confirm
      user={user}
      isFulfilling={isFulfilling}
      onSubmit={onSubmit}
      fullNameText={fullNameText}
      yourBirthdayText={yourBirthdayText}
      titleText={titleText}
      bodyText={bodyText}
      buttonText={buttonText}
      waiverLabelText={waiverLabelText}
      waiverLink={waiverLink}
      waiverLinkText={waiverLinkText}
      ageConfirmationLabelText={ageConfirmationLabelText}
    />
  )
}

export default ConfirmContainer
